import { render, staticRenderFns } from "./service-provider.vue?vue&type=template&id=b33a83b6&scoped=true"
import script from "./service-provider.vue?vue&type=script&lang=js"
export * from "./service-provider.vue?vue&type=script&lang=js"
import style0 from "./service-provider.vue?vue&type=style&index=0&id=b33a83b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33a83b6",
  null
  
)

export default component.exports